<template>
  <common-dialog ref="dialog" :title="title" width="1000px" :in-dialog="inDialog">
    <list ref="list" common :show-checkbox="multiple" :typeList="typeList" :checkbox-fixed="false" :show-status="false">
      <template #column>
        <slot name="column" />
        <el-table-column
          label="操作"
          align="center"
          width="60"
          fixed="right"
          v-if="selectable&&!multiple"
        >
          <template slot-scope="{row}">
            <el-button @click="onSelect(row)" type="text">选择</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <template slot="footer">
      <slot name="footer">
        <el-button size="mini" type="primary" @click="selectMultiple" v-if="selectable&&multiple">选择</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "./DList";
import listDialogMixins from "@/mixins/listDialog";
export default {
  components: { commonDialog, list },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "单位列表",
    },
    typeList: {
      default: () => [1,2,3]
    }
  },
  methods: {
   
  },
};
</script>